// extracted by mini-css-extract-plugin
export var fadeInAnimation = "DefaultLogosFooter-module--fadeInAnimation--199d8";
export var title = "DefaultLogosFooter-module--title--cb94c";